export default __webpack_public_path__ + "1166cf4f6773a25c727639d95504d144.png";